<template>
    <div id="container" class="container">
        <myheader2></myheader2>
        <div class="main-page-outer min-width">
            <div class="mx1360 main-count2 flex-r">
                <div class="left-cont">
                    <centerNavBar name="我的作品"></centerNavBar>
                </div>
                <div class="right-cont">
                    <div class="work-block">
                        <workList ref="workTemp"></workList>
                    </div>
                </div>
            </div>
        </div>
        <myfooter2></myfooter2>
    </div>
</template>

<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js"
import workList from "../components/workList.vue";


export default {
    name: "mywork",
    components: {
        workList
    },
    data() {
        return {
            dialogVisible: true,
            baseInfo: {
                cnt1: 0,
                cnt2: 0,
                cnt3: 0,

            },
        }
    },
    created() {
        that = this;
    },
    mounted() {
        this.$refs.workTemp.initData()
    },
    methods: {
        
        goPage(path) {
            util.tourl(path)
        },
        prevClick(e) {
            console.log(e)
        },
        nextClick(e) {
            console.log(e)
        },
        sizeChange(e) {
            console.log(e)
        },
        currentChange(e) {
            console.log(e)
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../style.scss'; //所有页面公用
@import '../../style2.scss'; //所有页面公用
@import './mywork.scss';
</style>